/* eslint-disable camelcase */
import * as utils from '@utils/form';

export const SCHEDULE_FIELDS = {
  COUNTRY: {
    name: 'countryName',
    serialize: (field, values) => {
      return { countryName: values.countryName.name, countryId: values.countryName.id };
    },
    deserialize: (field, serverData) => {
      const id = serverData.countryId;
      const name = serverData.countryName;

      return { [field.name]: { id, name } };
    },
  },
  EVENT: {
    name: 'event',
    label: 'Event:',
    rules: [{ required: true, message: 'Event is required' }],
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.relatedEntityDeserializer,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  DAYS: {
    name: 'days',
  },
  EVENT_FIELDS: {
    name: 'eventName',
    serialize: (field, values) => {
      return {
        eventId_WA: values.eventName.eventId_WA,
        eventName: values.eventName.eventName,
        eventId: values.eventName.eventId,
      };
    },
    deserialize: (field, serverData) => {
      const eventId_WA = serverData.eventId_WA;
      const eventName = serverData.eventName;
      const eventId = serverData.eventId;

      return { [field.name]: { eventId_WA, eventName, eventId } };
    },
  },
};

export const CHANNEL_FIELDS = {
  CATEGORY: {
    name: 'category',
    label: 'Category',
    placeholder: 'Choose category',
    options: [
      { label: 'TV Live', value: 'TV Live' },
      { label: 'TV Highlights', value: 'TV Highlights' },
      { label: 'Live Stream', value: 'Live Stream' },
      { label: 'Highlights', value: 'Highlights' },
      { label: 'Radio', value: 'Radio' },
      { label: 'Discipline feeds', value: 'Discipline feeds' },
    ],
    rules: [{ required: true, message: 'Category is required' }],
  },
  CHANNEL: {
    name: 'channel',
    label: 'Channel',
    placeholder: 'Type to search channel:',
    serialize: (field, values) => {
      return {
        title: values.channel.title,
        id: values.channel.id,
        logoId: values.channel.logoId,
        logoFileName: values.channel.logoFileName,
      };
    },
    deserialize: (field, serverData) => {
      const id = serverData.id;
      const title = serverData.title;
      const logoId = serverData.logoId;
      const logoFileName = serverData.logoFileName;

      return { [field.name]: { id, title, logoId, logoFileName } };
    },
  },
  TIME: {
    name: 'time',
    label: 'Time',
  },
};

export const SCHEDULE_INITS = {
  id: '',
  days: [],
  eventName: '',
  eventId: null,
  countryId: '',
  countryName: '',
  eventId_WA: null,
};

export const CHANNEL_INITS = {
  category: 'TV Live',
  channel: {},
  time: [],
};
